export default __webpack_public_path__ + "static/pet-place-6fed2e96f1898464813df91b3c8705f5.jpg";